<template>
  <header class="home-header">
    <figure v-scroll:reveal="{ delay: 225 }" class="branch-image -home">
      <img src="/images/pexels-ron-lach.png" alt="" class="branch-image__background -offset" />
      <BranchOverlay class="branch-image__overlay" />
    </figure>

    <div class="home-header__content">
      <h1 v-scroll:reveal="{ delay: 100 }" class="home-header__banner">
        {{ wp.header.title }}
      </h1>
      <p v-scroll:reveal="{ delay: 175 }" class="home-header__text">
        {{ wp.header.text }}
      </p>

      <div class="home-header__cta">
        <RouterLink v-scroll:reveal="{ delay: 250 }" :to="{ name: 'project-index' }" class="button">
          Explorez nos projets
        </RouterLink>

        <RouterLink
          v-scroll:reveal="{ delay: 250 }"
          :to="{ name: 'about-members-register' }"
          class="button -transparent"
        >
          Devenir membre
          <SvgIcon id="action-arrow" />
        </RouterLink>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'HomeHeader',
  inject: ['wp']
}
</script>
